<div class="bg-th-blue mt-0 container-fluid py-2">
    <div class=" d-flex justify-content-between align-content-center">
        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>
        <a class="text-white f18 my-auto dirI d-flex align-items-center">سرویس های دوره ای <i
                class="fa fa-question-circle my-auto me-2 fa-2x" (click)="guid(31)"></i></a>
    </div>
</div>

<div class="d-flex justify-content-end gap-2 p-2 me-2">
    <button class="btn btn-success pointer"
        (click)="otherService.exportexcel( 'excel-table-periodicServices', 'گزارش سررسید سرویس ها.xlsx') "> خروجی اکسل
        <i class="fa fa-file-excel-o"></i></button>
    <button printTitle="گزارش سررسید سرویس ها" printSectionId="print-table-periodicServices"
        class="btn btn-secondary pointer" [useExistingCss]="true" ngxPrint>چاپ <i class="fa fa-print"></i></button>
</div>

<div class="table-responsive dirI rounded-3  my-2" id="print-table-periodicServices"
    style="max-height: 85vh; overflow-y: auto;">
    <div class="row dirI" id="print-only-flex">
        <div class="col-10 text-center align-items-center border">
            <p class="mt-2 fw-bold">
                {{loggedInUser}}
            </p>
            <p>سرویس های دورهای {{vehicle.owner}} با شماره پلاک {{vehicle.plate.split("").reverse().join("")}} از {{vehicle.company}}</p>
        </div>
        <div class="col-2 text-center align-items-center border">
            <p class="p-2">تاریخ تهیه</p>
            {{otherService.getCurrentDate() | faNum}}
        </div>
    </div>

    <table class="table table-striped mt-1 dirI" id="excel-table-periodicServices">

        <thead class="">

            <tr class="text-center">

                <th scope="col" class=""># </th>

                <th scope="col" class=""> کاربر ثبت کننده </th>

                <th scope="col" class="">موضوع</th>

                <th scope="col" class="">سررسید</th>

                <th scope="col" class="">تاریخ</th>

                <th scope="col" class="">کیلومتر</th>

                <th scope="col" class="">وضعیت</th>

            </tr>

        </thead>

        <tbody>

            <tr class="text-center f14 pointer" (click)="getSingel(i)" 
            
                [ngClass]="item.iStatus == 0 ? 'bg-green-light' : 'bg-pink'" 
                
                *ngFor="let item of Service;let i=index">

                <th class="text-dark">{{i+1 | faNum}}</th>

                <th class="text-dark">{{item.strUserSaved | faNum}}</th>

                <th class="text-dark">{{item.strRepairMaintenanceSubject_strComment | faNum}}</th>

                <th class="text-dark">{{item.strMaintenanceMaturity_strComment | faNum}}</th>

                <th class="text-dark">{{item.strDate | faNum}}</th>

                <th class="text-dark">{{otherService.getSeparatedValue(item.iKM)}}</th>

                <th [ngClass]="item.iStatus == 2 ? 'text-muted' : 'text-primary' ">

                    {{
                        item.iStatus == 0 ? 'هنوز برای انجام این سرویس مهلت دارید':

                        item.iStatus == 1? 'فرصت کمی تا انجام این سرویس باقی مانده است':

                        item.iStatus == 2? 'زمان انجام این سرویس گذشته است' : ''
                    
                    }}

                </th>

                <th class="text-primary">{{item.strVIN }}</th>

            </tr>

        </tbody>

    </table>

</div>

<!-- Button trigger modal -->
 
<button type="button" class="btn btn-primary btn-plus" data-bs-toggle="modal" data-bs-target="#exampleModal"
    (click)="open()">
    <i class="fa fa-plus fa-2x"></i>
</button>

<!-- Modal -->
<div class="modal fade rtl " id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title text-th-blue d-flex align-items-center" id="exampleModalLabel">

                    <span>سرویس های دوره ای</span>

                    <i class="fa fa-question-circle my-auto me-2 fa-2x pointer" (click)="guid(6)"></i>

                </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body ">

                <form [formGroup]="sabtModel" class="d-flex justify-content-around flex-wrap">

                    <div class="col-md-5 col-11 mx-auto mt-2">

                        <label class="mb-2">  نوع تعمیر نگهداری * </label>

                        <select class="form-select shadow  " formControlName="iRepairMaintenanceSubject"

                            [attr.disabled]="EditeMod  ? '' : null">

                            <option *ngFor="let item of ServiceTxt2" value="{{item.iRepairMaintenanceSubject}}">

                                {{item.strComment}}</option>

                        </select>

                    </div>

                    <div class="col-md-5 col-11 mx-auto mt-2">

                        <label class="mb-2">نوع سر رسید</label>

                        <select class="form-select shadow " #tiMaturity formControlName="tiMaintenanceMaturity"

                            [attr.disabled]="EditeMod  ? '' : null" (change)="handelselect($event)">

                            <option *ngFor="let item of ServiceTxt" value="{{item.tiMaintenanceMaturity}}">

                                {{item.strComment}}
                            
                            </option>

                        </select>


                    </div>

                    <div class="col-md-5 col-11 mx-auto mt-2" *ngIf="KmInp">

                        <label class="mb-2">مسافت خدمات به کیلو متر</label>

                        <input type="text" class="form-control shadow  text-end lirI" formControlName="iKM"

                            (keypress)="seprator($event)" />

                    </div>

                    <ng-container *ngIf="tiMaturity.value == 5">

                        <div class="col-md-5 col-11 mx-auto mt-2">

                            <label class="mb-2"> ساعت خودرو * </label>
    
                            <input type="text" class="form-control shadow  text-end lirI" formControlName="iWorkHours"
    
                                (keypress)="seprator($event)" />
    
                        </div>

                    </ng-container>

                    <div class="col-md-5 col-11 mx-auto" *ngIf="dateInp">

                        <label class="mt-2"> تاریخ سر رسید * </label>

                        <form [formGroup]="datasabt">

                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"

                                [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                                <input type="text" formControlName="date" class="form-control shadow text-end"

                                    readonly />

                            </ng-persian-datepicker>

                        </form>

                    </div>


                    <div class="col-11 mx-auto mt-2">

                        <label class="mb-2">توضیحات</label>

                        <textarea type="text" class="form-control shadow" formControlName="strComment"

                            placeholder="توضیحات">
                        
                        </textarea>

                    </div>

                </form>

            </div>

            <div dir="ltr" class="modal-footer">

                <button type="button" class="btn btn-success" (click)="sabt()" *ngIf="!EditeMod">ذخیره <i

                        class="fa fa-angle-double-down"></i> </button>

                <button type="button" class="btn btn-success" (click)="edit()" *ngIf="EditeMod">ویرایش<i

                        class="fa fa-edit"></i></button>

                <button type="button" class="btn btn-danger" (click)="deleteService()" *ngIf="EditeMod">حذف <i

                        class="fa fa-trash"></i></button>

                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="close()">بستن<i

                        class="fa fa-close"></i></button>
            </div>

        </div>

    </div>

</div>